import React from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import axios from "../../api/axios";

const AddressBookIndividual = () => {
  const navigate = useNavigate();
  const state = useSelector((state) => state.UserReducer);
  const { addressBookId } = useParams();
  const getUrl = "/addressbook/" + addressBookId;
  const enquiryUrl = "/enquiry";

  const [addressBookDataFromServer, setAddressBookDataFromServer] =
    React.useState({});
  const [enquiryData, setEnquiryData] = React.useState([]);
  const renderStatus = (status) => {
    switch (status) {
      case "NEW":
        return (
          <span className='bg-blue-100 text-blue-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800'>
            NEW
          </span>
        );
      case "ASSIGNED":
        return (
          <span className='bg-orange-100 text-orange-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-orange-200 dark:text-orange-900'>
            ASSIGNED
          </span>
        );
      case "IN-PROCESS":
        return (
          <span className='bg-green-100 text-green-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
            IN&nbsp;PROCESS
          </span>
        );
      case "DROPPED":
        return (
          <span className='bg-red-100 text-red-600 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-red-200 dark:text-red-900'>
            DROPPED
          </span>
        );
    }
  };

  const getAddressBook = () => {
    try {
      axios
        .get(getUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.addressBook) {
            setAddressBookDataFromServer(response.data.addressBook);
            setEnquiryData(response.data.relatedEnquiries);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getAddressBook();
  }, []);

  return (
    <>
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='px-4 py-0 sm:px-0'>
              <div className='block'>
                <div className='shadow overflow-hidden sm:rounded-md'>
                  <div className='px-4 py-5 bg-white sm:p-6'>
                    <div className='lg:flex lg:items-center justify-between'>
                      <div className='flex-1 min-w-0 px-0 lg:px-0'>
                        <h2 className='text-lg font-semibold leading-3 text-gray-dark sm:text-lg '>
                          {addressBookDataFromServer?.customerID ? (
                            <p>
                              Address Book - #{" "}
                              {addressBookDataFromServer?.customerID}
                            </p>
                          ) : (
                            <span className='mt-1 block w-full py-0  sm:text-sm'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                                <div className='w-56 bg-yellow-2 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </h2>
                      </div>
                    </div>
                    <div className='mt-3 sm:mt-4 grid grid-cols-12 gap-3'>
                      <div className='col-span-12 sm:col-span-3'>
                        <label
                          htmlFor='prefix'
                          className='block text-xs font-medium text-gray-700'>
                          Client Name
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.prefix}.&nbsp;
                            {addressBookDataFromServer.firstName}
                            &nbsp;
                            {addressBookDataFromServer.lastName
                              ? addressBookDataFromServer.lastName
                              : ""}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-6 sm:col-span-2'>
                        <label
                          htmlFor='contactTime'
                          className='block text-xs font-medium text-gray-700'>
                          Contact Time
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.contactTime}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-5 sm:col-span-2'>
                        <label
                          htmlFor='customerType'
                          className={`block text-xs font-medium text-gray-700`}>
                          Customer Type
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.customerType}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-8 sm:col-span-2'>
                        <label
                          htmlFor='first-name'
                          className={`block text-xs font-medium text-gray-700`}>
                          Mobile #
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            ({addressBookDataFromServer?.countryCode?.trim()}
                            )&nbsp;
                            {addressBookDataFromServer.phoneNumber}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-8 sm:col-span-2'>
                        <label
                          htmlFor='alternatePhone'
                          className={`block text-xs font-medium text-gray-700`}>
                          Alternate Phone
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.alternatePhone}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-8 sm:col-span-3'>
                        <label
                          htmlFor='email'
                          className={`block text-xs font-medium text-gray-700`}>
                          Email Address
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.email
                              ? addressBookDataFromServer.email
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='mt-10 lg:flex lg:items-center justify-between'>
                      <div className='flex-1 min-w-0 px-0 lg:px-0'>
                        <h2 className='text-lg font-semibold leading-3 text-gray-dark sm:text-lg '>
                          Additional Information
                        </h2>
                      </div>
                    </div>
                    <div className='mt-3 sm:mt-2 grid grid-cols-12 gap-3'>
                      <div className='col-span-6 sm:col-span-2'>
                        <label
                          htmlFor='dateOfBirth'
                          className='block text-xs font-medium text-gray-700'>
                          DOB
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer?.dateOfBirth?.slice(
                              0,
                              10,
                            )}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-6 sm:col-span-2'>
                        <label
                          htmlFor='channel'
                          className='block text-xs font-medium text-gray-700'>
                          Channel
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.channel
                              ? addressBookDataFromServer.channel
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      {["Reference", "Agent", "Others"].includes(
                        addressBookDataFromServer.channel,
                      ) ? (
                        <div className={`col-span-12 sm:col-span-3`}>
                          <label
                            htmlFor='referenceName'
                            className={`block text-xs font-medium text-gray-700`}>
                            {addressBookDataFromServer.channel === "Reference"
                              ? "Reference Name"
                              : addressBookDataFromServer.channel === "Agent"
                              ? "Agent Name"
                              : "Others"}
                          </label>
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.referenceName
                              ? addressBookDataFromServer.referenceName
                              : "--"}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}
                      <div className='col-span-5 sm:col-span-3'>
                        <label
                          htmlFor='crm'
                          className='block text-xs font-medium text-gray-700'>
                          CRM
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.crm
                              ? addressBookDataFromServer.crm?.fullname
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-7 sm:col-span-3'>
                        <label
                          htmlFor='crmReview'
                          className='block text-xs font-medium text-gray-700'>
                          CRM Review
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.crmReview
                              ? addressBookDataFromServer.crmReview
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-12 sm:col-span-3'>
                        <label
                          htmlFor='addressLine1'
                          className={`block text-xs font-medium text-gray-700`}>
                          Address Line 1
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.addressLine1
                              ? addressBookDataFromServer.addressLine1
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-12 sm:col-span-3'>
                        <label
                          htmlFor='addressLine2'
                          className={`block text-xs font-medium text-gray-700`}>
                          Address Line 2
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.addressLine2
                              ? addressBookDataFromServer.addressLine2
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-6 sm:col-span-2'>
                        <label
                          htmlFor='city'
                          className={`block text-xs font-medium text-gray-700`}>
                          City
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.city
                              ? addressBookDataFromServer.city
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-6 sm:col-span-2'>
                        <label
                          htmlFor='state'
                          className={`block text-xs font-medium text-gray-700`}>
                          State
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.state
                              ? addressBookDataFromServer.state
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-6 sm:col-span-2'>
                        <label
                          htmlFor='country'
                          className={`block text-xs font-medium text-gray-700`}>
                          Country
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.country
                              ? addressBookDataFromServer.country
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>

                      <div className='col-span-6 sm:col-span-1'>
                        <label
                          htmlFor='pincode'
                          className={`block text-xs font-medium text-gray-700`}>
                          Pincode
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.pincode
                              ? addressBookDataFromServer.pincode
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-5 sm:col-span-2'>
                        <label
                          htmlFor='occupationType'
                          className='block text-xs font-medium text-gray-700'>
                          Occupation
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.occupationType
                              ? addressBookDataFromServer.occupationType
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-7 sm:col-span-3'>
                        <label
                          htmlFor='occupiedIndustry'
                          className='block text-xs font-medium text-gray-700'>
                          Occupational Industry
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.occupiedIndustry
                              ? addressBookDataFromServer.occupiedIndustry
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-12 sm:col-span-3'>
                        <label
                          htmlFor='designation'
                          className='block text-xs font-medium text-gray-700'>
                          Designation
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.designation
                              ? addressBookDataFromServer.designation
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-6 sm:col-span-2'>
                        <label
                          htmlFor='vehicleUsed'
                          className='block text-xs font-medium text-gray-700'>
                          Vehicle Used
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.vehicleUsed
                              ? addressBookDataFromServer.vehicleUsed
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-6 sm:col-span-2'>
                        <label
                          htmlFor='kidsCount'
                          className='block text-xs font-medium text-gray-700'>
                          No. of Kids
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.kidsCount
                              ? addressBookDataFromServer.kidsCount
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-12 sm:col-span-6'>
                        <label
                          htmlFor='miscellaneousInformation'
                          className='block text-xs font-medium text-gray-700'>
                          Miscellaneous Information
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.miscellaneousInformation
                              ? addressBookDataFromServer.miscellaneousInformation
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-12 sm:col-span-6'>
                        <label
                          htmlFor='callSummary'
                          className='block text-xs font-medium text-gray-700'>
                          Call Summary
                        </label>
                        {addressBookDataFromServer?.customerID ? (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            {addressBookDataFromServer.callSummary
                              ? addressBookDataFromServer.callSummary
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                    </div>
                    {enquiryData?.length > 0 && (
                      <div>
                        <h4 className='text-lg mt-2 font-semibold'>
                          Related Enquiries
                        </h4>
                        <div className='mt-3 grid grid-cols-12 gap-4 sm:gap-2 pb-1'>
                          {enquiryData?.length > 0 ? (
                            enquiryData?.map((item) => (
                              <div
                                key={item?.enquiryID}
                                className='px-2 py-2 col-span-12 sm:col-span-3 bg-orange-50 shadow rounded border border-yellow-2'
                                onClick={(e) => {
                                  navigate(enquiryUrl + "/" + item?._id, {
                                    replace: false,
                                  });
                                }}>
                                <div className='grid grid-cols-6'>
                                  <div className='col-span-4'>
                                    <h4 className='text-gray-dark font-semibold text-sm tracking-wide pl-2 pt-1'>
                                      #{item?.enquiryID} |{" "}
                                      {item?.leadEnteredDate.slice(0, 10)}
                                    </h4>
                                  </div>
                                  <div className='col-span-2'>
                                    <h4 className='text-gray-dark font-bold text-sm tracking-wide pt-1 text-right'>
                                      {renderStatus(item?.status)}
                                    </h4>
                                  </div>

                                  <div className='col-span-6 overflow-hidden'>
                                    <h4 className='text-gray-dark font-normal text-xs tracking-wide pl-2 pt-1 text-left'>
                                      {item?.serviceTypeId?.name} &gt;{" "}
                                      {item?.subServiceTypeId?.name}
                                    </h4>
                                  </div>
                                  <div className='col-span-6 overflow-hidden'>
                                    <h4 className='text-gray-dark font-normal text-xs tracking-wide pl-2 pt-1 text-left'>
                                      {item?.propertyOptionId?.name} &gt;{" "}
                                      {item?.subPropertyOptionId?.name}
                                    </h4>
                                  </div>

                                  {/* <div className='col-span-2 pt-2 pl-2'>
                                    <div className='grid grid-cols-2 gap-2'>
                                      <div className=''>
                                        <Link
                                          to={`/enquiry/edit/"+${item?._id}`}>
                                          <h4 className='font-semibold text-base text-yellow-2 text-left pr-2'>
                                            Edit
                                          </h4>
                                        </Link>
                                      </div>
                                      <div className=''>
                                        <h4
                                          onClick={() => {
                                            // confirmDelete(
                                            //   item?._id,
                                            //   item?.firstName,
                                            //   item?.lastName,
                                            // );
                                          }}
                                          className='cursor-pointer font-semibold text-base text-red-600 text-left pr-2'>
                                          Delete
                                        </h4>
                                      </div>
                                    </div>
                                  </div> */}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='px-4 py-3 bg-gray-50 text-right sm:px-6'>
                    <div className='lg:flex lg:items-center justify-between'>
                      <div className='flex-1 min-w-0 px-0 lg:px-0'>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(-1);
                          }}
                          className='inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-xs font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                          Back
                        </button>
                        <button
                          id='submitBtn'
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(
                              "/addressbook/edit/" +
                                addressBookDataFromServer._id,
                            );
                          }}
                          className='ml-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                          Edit
                        </button>
                      </div>
                    </div>
                    <div className='sm: py-2'></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default AddressBookIndividual;
